module.exports = __webpack_public_path__ + "static/media/sb_expansion_inactive_icon.fc0db19a.svg";